<div *ngIf="ordiniDownloadComplete">
  <div *ngIf="!serverError; else errorBlock">
    <div *ngIf="erroreGestitoMex == null; else erroreGestitoBlock">
      <div
        class="dashboard-table-wrapper"
        *ngIf="ordiniPresenti; else noOrdiniBlock">
        <ds-table
          class="dashboard-table"
          [tableConfig]="tableConfig"
          [attr.table-empty-title]="'emptyTableTitle' | translate"
          [attr.table-empty-description]="'emptyTableDescription' | translate"
          [attr.table-empty-image-url]="emptyImage"
          [attr.table-empty-image-alt]="'emptyTableAltImage' | translate"
          (onClickSecondRightAction)="
            onSecondRightIconClick($event)
          "></ds-table>
          <app-table-legend
        *ngIf="tableConfig.tableRows && tableConfig.tableRows.length > 0"
        [items]="legendItems">
      </app-table-legend>
      </div>
      <ng-template #noOrdiniBlock>
        <app-no-element [isDocument]="false"></app-no-element>
      </ng-template>
    </div>
    <ng-template #erroreGestitoBlock>
      <div>
        <app-no-element [isDocument]="false"></app-no-element>
      </div>
    </ng-template>
  </div>
  <ng-template #errorBlock>
    <div>
      <app-no-element [isDocument]="false"></app-no-element>
    </div>
  </ng-template>
</div>

<ds-spinner
  *ngIf="!ordiniDownloadComplete"
  [attr.spinner-ui-variant]="'spinner'"
  [attr.spinner-aria-label]="'Caricamento' | translate"></ds-spinner>
